import Global from "../../Global/Global";

export const apiUrl = "https://apiapp.innovairsolutions.com/";

export default apiUrl;
